import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { AssessmentQuality } from '../../../../models/assessment.types';
import { ToleranceRange } from '../../../../pages/Sessions/SessionsParametersDialog/ToleranceRange/ToleranceRange.types';
import { AssessmentSessionProcessTypeId } from '../../../../services/exams/assessmentSession/assessments.types';
import { getAssessmentQualityLabel, getColor, getPillTooltip } from '../../../../utils/assessmentQuality';
import { SampleAssessmentPill } from '../../../SampleAssessmentPill/SampleAssessmentPill.component';
import TooltipOne from '../../../TooltipOne/TooltipOne.component';

interface ClosedStatusFooterProps {
  totalScore: number | null;
  maxTotalScore: number;
  sampleAssessmentScoreSum: number;
  assessmentQuality: AssessmentQuality | null;
  finalAssessmentQuality: AssessmentQuality | null;
  processTypeId: AssessmentSessionProcessTypeId;
  toleranceRange: ToleranceRange | null;
}

export const ClosedStatusFooter: React.FC<ClosedStatusFooterProps> = (props) => {
  const textSize = { fontSize: '14px' };

  return (
    <Grid container justifyContent="center" style={{ width: '334px', padding: '2px 10px' }}>
      <Grid container>
        <Grid item>
          <Typography style={{ display: 'inline-flex', ...textSize }}>
            Suma pkt:&nbsp;
            {props.assessmentQuality !== null ? (
              <SampleAssessmentPill
                sampleAssessmentPoints={props.totalScore}
                sampleAssessmentSum={props.maxTotalScore}
                assessmentQuality={props.assessmentQuality}
                processTypeId={props.processTypeId}
                tooltip={
                  (props.assessmentQuality !== null && props.toleranceRange
                    ? getPillTooltip(
                        props.processTypeId,
                        props.toleranceRange?.toleranceRangeType,
                        props.toleranceRange?.toleranceRangeValue,
                      )
                    : '') as string
                }
              />
            ) : (
              <div>
                {props.totalScore}/{props.maxTotalScore}
              </div>
            )}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <hr style={{ color: '#2c2d3e', opacity: 0.3 }} />
      </Grid>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Typography style={textSize}>
            Suma wzorcowa:&nbsp;
            <Typography style={{ display: 'inline-flex', fontWeight: 'bold', ...textSize }}>
              {props.sampleAssessmentScoreSum}
            </Typography>
          </Typography>
        </Grid>
        <Grid item>
          <Typography
            style={{
              color: getColor(props.finalAssessmentQuality, props.processTypeId),
              fontWeight: 'bold',
              ...textSize,
            }}
          >
            {getAssessmentQualityLabel(props.processTypeId, props.finalAssessmentQuality)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
